import { useEffect, useState } from "react";

export const SESSIONS = [
  { id: "oct27", label: "Tuesday, October 27 · 7:30 PM ET", short: "TUE, OCT 27", date: new Date("2026-10-27T19:30:00-04:00") },
  { id: "oct29", label: "Thursday, October 29 · 7:30 PM ET", short: "THU, OCT 29", date: new Date("2026-10-29T19:30:00-04:00") },
];

export const nextSession = () =>
  SESSIONS.find((s) => s.date.getTime() > Date.now()) || SESSIONS[SESSIONS.length - 1];

export const DATE_LABEL = "Tue, Oct 27 & Thu, Oct 29, 2026 · 7:30 PM Eastern";
export const DATE_SHORT = "OCT 27 & 29 · 7:30 PM ET";

const remaining = () => Math.max(0, nextSession().date.getTime() - Date.now());

export const useCountdown = () => {
  const [ms, setMs] = useState(remaining);
  useEffect(() => {
    const t = setInterval(() => setMs(remaining()), 1000);
    return () => clearInterval(t);
  }, []);
  const s = Math.floor(ms / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s / 3600) % 24),
    mins: Math.floor((s / 60) % 60),
    secs: s % 60,
  };
};

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ compact = false, light = false }) => {
  const { days, hours, mins, secs } = useCountdown();
  const units = [[days, "DAYS"], [hours, "HRS"], [mins, "MIN"], [secs, "SEC"]];
  if (compact) {
    return (
      <span className="font-mono font-bold tabular-nums" data-testid="countdown-compact">
        {days}d : {pad(hours)}h : {pad(mins)}m : {pad(secs)}s
      </span>
    );
  }
  return (
    <div data-testid="countdown-wrap">
      <p className={`text-[11px] font-bold tracking-[0.15em] mb-2 ${light ? "text-[#98A2B3]" : "text-white/50"}`} data-testid="countdown-label">
        NEXT SESSION — {nextSession().short} · 7:30 PM ET
      </p>
      <div className="flex gap-3" data-testid="countdown-timer">
        {units.map(([v, l]) => (
          <div key={l} className={`flex flex-col items-center rounded-xl px-4 py-3 min-w-[70px] ${light ? "bg-white border border-[#EAECF0] shadow-sm" : "bg-[#101828] border border-white/10"}`}>
            <span className={`text-2xl font-black tabular-nums ${light ? "text-[#1D2939]" : "text-white"}`}>{pad(v)}</span>
            <span className={`text-[10px] font-bold tracking-[0.15em] ${light ? "text-[#98A2B3]" : "text-white/50"}`}>{l}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
